type ValueOf<T> = T[keyof T];
export interface ShiftProviderProps {
  children?: React.ReactNode;
  scenario?: string;
}
export interface Shift {
  id: string;
  startDate: string;
  endDate: string;
  shiftLength: number;
  providerType: string;
  providerCount: number;
  hours: number;
  status?: 'delete' | 'new' | 'update';
  baseStartDate?: string;
}
export interface ShiftDataCollection {
  [key: Shift['id']]: Shift;
}
export interface ShiftProviderState {
  shifts: {
    data: ShiftDataCollection;
    isLoading: boolean;
  };
}
export interface ShiftProviderContextProps {
  state: ShiftProviderState;
  dispatch: React.Dispatch<ShiftProviderAction>;
}
export const ShiftProviderTypes = {
  UPDATE_SHIFT: 'UPDATE_SHIFT',
  SET_SHIFT: 'SET_SHIFT',
  SET_SHIFT_LOADING: 'SET_SHIFT_LOADING',
} as const;
export interface ShiftProviderAction {
  type: ValueOf<typeof ShiftProviderTypes>;
  payload?: any;
}
